import { useCustomerDetails } from '@egw/api'
import { Field, ModalDrawer } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { type FC, useState } from 'react'
import { UpdateEmail } from './update-email'

export const EditEmailField: FC = () => {
  const { t } = useTranslation('features-settings')
  const [openEdit, setOpenEdit] = useState<boolean>(false)
  const [modalTitle, setModalTitle] = useState<string>(t('personal_info.change_email'))

  const { data } = useCustomerDetails()

  const email = data?.customer.email ?? ''

  return (
    <>
      <Field
        valueClassName="font-light"
        className="w-full justify-between border-list mb-0 py-4 px-2"
        onEdit={() => {
          setOpenEdit(true)
        }}
        value={email}
        isPII
      />
      <ModalDrawer
        title={modalTitle}
        isOpen={openEdit}
        onClose={() => {
          setOpenEdit(false)
        }}
      >
        <UpdateEmail
          closeModal={() => {
            setOpenEdit(false)
          }}
          setModalTitle={setModalTitle}
        />
      </ModalDrawer>
    </>
  )
}
